import React from 'react'
import { Button, Col, message, Modal, Row, Typography } from 'antd'
import { useDispatch } from 'react-redux'
import {
  billingActions,
  useBillingSelector,
} from 'store/billingSlice/billingReducer'
import { useAuthSelector } from 'store/authSlice/authReducer'
import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { awsconfig, config } from 'configs'
import { updateBillingPaymentMethod } from 'store/billingSlice/billingActions'
import { Can } from 'permissions'
const { Title, Text } = Typography

const WrappedChangePaymentMethod = ({ visible, onClose }) => {
  const dispatch = useDispatch()
  const { organization } = useAuthSelector()
  const {
    loading: { updatingPaymentMethod },
  } = useBillingSelector()
  const stripe = useStripe()
  const elements = useElements()

  /* eslint-disable consistent-return */
  const handleChangePaymentMethod = async () => {
    dispatch(billingActions.setLoading({ updatingPaymentMethod: true }))
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardElement),
    })
    if (error) {
      message.error(error?.message || 'Invalid Card Information')
      dispatch(billingActions.setLoading({ updatingPaymentMethod: false }))
      return false
    }
    const cardToken = paymentMethod.id
    const organizationId = organization?.id
    const payload = {
      cardToken,
    }
    dispatch(updateBillingPaymentMethod(organizationId, payload))
  }

  return (
    <Modal
      centered
      keyboard
      title={
        <Title level={3} style={{ margin: 0 }}>
          Payment method
        </Title>
      }
      open={visible}
      onCancel={() => {
        onClose()
      }}
      footer={null}
      destroyOnClose
    >
      <Row gutter={[0, 16]}>
        <Col>
          <Typography className="t-text-roboto t-text-[22px] t-leading-[25.78px] t-font-normal t-text-[rgba(0,0,0,0.6)]">
            Choose how you’d like to pay for extension subscription.
          </Typography>
          <Typography className="t-text-roboto t-text-4 t-leading-[18.75px] t-font-medium t-mt-4 t-mb-2">
            Enter Card Number
          </Typography>
          <div className="t-p-2 t-rounded-md t-border t-border-grey-900">
            <CardElement
              options={{
                style: {
                  base: {
                    fontSize: '15px',
                    fontSmoothing: 'antialiased',
                  },
                },
              }}
            />
          </div>
        </Col>
        <Col span={24}>
          <Text>
            <Text strong>Note:</Text> Add any messages (optional).
          </Text>
        </Col>
      </Row>
      <Can
        I={config.actions.edit}
        a={config.components.organizationSubscription}
        passThrough
      >
        {(allowed) => (
          <Row justify="space-between" align="bottom" className="t-mt-8">
            <Col>
              <Button
                style={{ backgroundColor: '#a8aaae29', borderRadius: '8px' }}
                disabled={!allowed}
                onClick={() => onClose()}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                style={{ borderRadius: '8px' }}
                loading={updatingPaymentMethod}
                disabled={!allowed}
                onClick={() => handleChangePaymentMethod()}
              >
                Update Payment Method
              </Button>
            </Col>
          </Row>
        )}
      </Can>
    </Modal>
  )
}

const StripeProvider = ({ visible, onClose }) => {
  const stripePromise = loadStripe(awsconfig.stripe_publish_key)
  return (
    <Elements stripe={stripePromise}>
      <WrappedChangePaymentMethod visible={visible} onClose={onClose} />
    </Elements>
  )
}

const ChangePaymentMethodModal = StripeProvider
export { ChangePaymentMethodModal }
